<template>
  <ModalPlay size="xs" hide-header @close="emit('close')">
    <div class="tw:flex tw:flex-col tw:gap-8">
      <TextPlay :text="$t('terms_of_use.advice_title')" color="var(--fontcolor)" weight="bold" size="2xl" />
      <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component vue/no-v-html -->
      <TextPlay color="var(--text-color)" v-html="$t('terms_of_use.advice_message')" />
      <ButtonPlayV2 variant="filled" :text="$t('terms_of_use.accept_terms')" @click="submit" />
    </div>
  </ModalPlay>
</template>

<script lang="ts" setup>
import { ModalPlay } from '@/components/atomic';

const props = defineProps<{
  onSubmit: () => void;
}>();

const emit = defineEmits(['close']);

function submit() {
  props.onSubmit();
  emit('close')
}

</script>
